import {IController} from "angular";
import * as angular from "angular";
import * as _ from "lodash";
import {RoutesService} from "../../../routes/services/routes-service.service";
// import {ExportType} from "../../../lean-planning/types/export.type";
import {RouteModel} from "../../../routes/models/route.model";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {TaskType} from "../../../tasks/types/task.type";
import {LeanPlanningService} from "../../../lean-planning/services/lean-planning-service.service";
import {TaskModel} from "../../../tasks/models/task.model";
import {ServicesService} from "../../services/services-service.service";
import {take} from "rxjs";
import {ServicesFacadeService} from "../../angular/services/services-facade.service";

export class ServicesActionBarComponent implements IController {
  selectedIds: string[] = [];
  onActionComplete: Function;
  onResetSelection: Function;


  public siteId: any;
  public allowPrintingBillOfLading: boolean;
  public routesRef: any;
  public enabledActions: any;
  public integrationExportRouteEnabled: boolean;
  public printerProvider: string;
  public servicesRef: any;
  public taskTypes: typeof TaskType = TaskType;
  public bindingTask: any;
  public totals: {numberOfItems: number, weightLoad?: number, calculatedVolume?: number};

  constructor(private servicesService: ServicesService, private splitService, private servicesFacadeService: ServicesFacadeService,
              private $deliveries, private commonsDialogService: CommonsDialogService, private DeliveriesApiAction) {
    this.siteId = this.splitService.getSiteId();
    this.printerProvider = this.splitService.getPrinterProvider();
    this.servicesRef = this.$deliveries();

  }

  $onInit() {
    this.setActions();
  }

  $onChanges(changes) {
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
      this.setActions();
    }
  };


  onOpen($mdMenu, $event) {
    $mdMenu.open($event);
  }

  setActions() {
    this.enabledActions = {};
    this.totals = undefined;

    if (!this.selectedIds?.length) {
      return;
    }

    this.servicesFacadeService.selectByIds(this.selectedIds).pipe(take(1)).subscribe((services) => {
      if (!!services.length) {
        // this._initActions(services);
      } else {
        // this.servicesRef.$asyncValues(this.selectedIds).then((services) => {
        //   this._initActions(services);
        // })
      }
    });
  }

  onActionSelect(action, event) {
    this.DeliveriesApiAction[action](event, this.selectedIds)
      .then((deliveryIds) => {
        if (_.isArray(deliveryIds) && deliveryIds.length) {
          this.onActionComplete();
        }
      })
  }

  // private _initActions(services) {
  //   const enabledActionsList = this.servicesService.getActionsByServices(services);
  //   this.enabledActions = _.keyBy(enabledActionsList, 'id');
  // }

}


angular
  .module('bringoz.admin.deliveries')
  .component('servicesActionBar', {
    bindings: {
      selectedIds: '<',
      onActionComplete: '&',
      onResetSelection: '&'
    },
    template: require('./services-action-bar.html').default,
    controller: ServicesActionBarComponent
  });
